module.exports = __webpack_public_path__ + "img/federated_states_of_micronesia.a262de2.webp";